enum EAutoScoreImageClass {
  Unknown = -1,
  NegativeHit = 0,
  PositiveHit = 1,
}

export default EAutoScoreImageClass;
